import React from 'react';
import clsx from 'clsx';
import { SearchBar } from '@tribeplatform/react-components/Search';
import { Card } from '@tribeplatform/react-ui-kit/Card';
export const HeroBannerBlock = ({ title, description, searchPlaceholder, align, textColor, backgroundType, backgroundColor, imagePosition, style, imageTintOpacity, image, extraPadding, }) => {
    var _a, _b, _c, _d;
    let backgroundTint = null;
    if (backgroundType === 'image') {
        backgroundTint =
            textColor === 'dark'
                ? `rgba(255,255,255,${imageTintOpacity / 100})`
                : `rgba(0,0,0,${imageTintOpacity / 100})`;
    }
    const wrapperStyle = {};
    if (backgroundType === 'color' && backgroundColor) {
        wrapperStyle.background = backgroundColor;
    }
    else if (backgroundType === 'image' && ((_b = (_a = image) === null || _a === void 0 ? void 0 : _a.urls) === null || _b === void 0 ? void 0 : _b.full)) {
        wrapperStyle.backgroundImage = `url(${(_d = (_c = image) === null || _c === void 0 ? void 0 : _c.urls) === null || _d === void 0 ? void 0 : _d.full})`;
    }
    const WrapperComponent = style === 'card' ? Card : 'div';
    return (React.createElement(WrapperComponent, { className: clsx(align === 'center' && 'text-center', align === 'trailing' && 'text-end', imagePosition === 'cover' && 'bg-cover', imagePosition === 'contain' && 'bg-contain bg-no-repeat', imagePosition === 'no-repeat' && 'bg-auto bg-no-repeat', style === 'rounded' && 'sm:rounded-lg', 'bg-center overflow-hidden'), style: wrapperStyle },
        React.createElement("div", { className: clsx(textColor === 'dark' ? 'text-black' : 'text-white', 'p-6'), style: {
                backgroundColor: backgroundTint,
            } },
            React.createElement("div", { className: "p-12", style: {
                    paddingTop: `${extraPadding}em`,
                    paddingBottom: `${extraPadding}em`,
                } },
                React.createElement("div", { className: "mb-10" },
                    React.createElement("h2", { className: "text-4xl mb-5" }, title),
                    React.createElement("div", null, description)),
                React.createElement("div", { className: "flex" },
                    align === 'trailing' && React.createElement("div", { className: "flex-grow" }),
                    React.createElement("div", { className: clsx(align === 'center' && 'mx-auto', 'max-w-full w-132') },
                        React.createElement(SearchBar, { entityType: "post", autoFocus: false, placeholder: searchPlaceholder })))))));
};
//# sourceMappingURL=Block.js.map